<template>
  <div class="top-menu">
    <div class="title">工具箱</div>
    <div class="menu-items">
      <button @click="goLogin()">管理员登录</button>
    </div>
  </div>
</template>

<script>

export default {
    name: 'TopMenuView',
    data() {
        return {
        }
    },
    methods: {
        goLogin(){
           this.$router.replace('/admin')
        }

    }
}
</script>

<style scoped>
.title{
    font-size:2rem;
    font-weight:bold;
}
.top-menu {
  background-color: #2c3e50;
  color: white;
  padding: 0.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu-items button {
  background: none;
  border: none;
  color: white;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1rem;
}

.menu-items button:hover {
  text-decoration: underline;
}
</style>